import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { history } from "../../../redux/store/configureStore";
import * as enrollmentActions from "../../../redux/actions/enrollmentActions";
import { buildManageRouteWithSchoolYear, getNormalizedSchoolYearStartYearFromSearch } from "../manageSchoolYearRouting";

function Enrollments({ enrollments, loadEnrollments }) {
  const [numToShow, setNumToShow] = useState(25);
  const location = useLocation();
  const activeSchoolYearStartYear = getNormalizedSchoolYearStartYearFromSearch(location.search);
  const visibleEnrollments = enrollments.filter(enrollment => !enrollment.deleted);

  useEffect(() => {
    if (enrollments.length === 0) {
      loadEnrollments().catch(error => alert(`Loading enrollments failed ${error}`));
    }
  }, [enrollments.length, loadEnrollments]);

  const handleAdd = () => {
    history.push(buildManageRouteWithSchoolYear("/manage/enrollment/new", location.search, activeSchoolYearStartYear));
  };

  const handleEdit = (enrollment) => {
    history.push(buildManageRouteWithSchoolYear(`/manage/enrollment/${enrollment.id}`, location.search, activeSchoolYearStartYear));
  };
  const handleEditKeyDown = (event, enrollment) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleEdit(enrollment);
    }
  };

  return (
    <div className="mb-5">
      <div className="row d-flex mx-0">
        <div className="manage-title">Zapisy</div>
        <div className="col-block ml-auto">
          <button type="button" className="btn manage-button btn-success btn-block" onClick={handleAdd}>
            Dodaj zapis
          </button>
        </div>
      </div>
      <div className="row table-header manage-table-title mx-0 d-flex align-items-center">
        <div className="col-md-3 col-4">Klient</div>
        <div className="col-md-3 col-4">Produkt</div>
        <div className="col-md-2 col-4">Status</div>
        <div className="col-md-2 d-none d-md-block">Start</div>
        <div className="col-md-2 d-none d-md-block">Pozycje</div>
      </div>
      {visibleEnrollments.slice(0, numToShow).map((enrollment, index) => (
        <div
          key={enrollment.id}
          role="button"
          tabIndex={0}
          className={`table-row row d-flex manage-text cursor-pointer mx-0 ${index % 2 !== 0 ? "table-row-alternate" : ""}`}
          onClick={() => handleEdit(enrollment)}
          onKeyDown={event => handleEditKeyDown(event, enrollment)}
        >
          <div className="col-md-3 col-4 table-cell">{enrollment.clientDisplayName || enrollment.clientId}</div>
          <div className="col-md-3 col-4 table-cell">{enrollment.productName || (enrollment.product && enrollment.product.name)}</div>
          <div className="col-md-2 col-4 table-cell">{enrollment.status || "draft"}</div>
          <div className="col-md-2 d-none d-md-block table-cell">{enrollment.startDate}</div>
          <div className="col-md-2 d-none d-md-block table-cell">{(enrollment.paymentScheduleItems || []).length}</div>
        </div>
      ))}
      {numToShow < visibleEnrollments.length && (
        <div className="pt-3 row d-flex justify-content-center mx-0">
          <div className="col-md-3 form-group">
            <button type="button" className="btn manage-button manage-red-button btn-block" onClick={() => setNumToShow(numToShow + 25)}>
              Pokaz wiecej
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

Enrollments.propTypes = {
  enrollments: PropTypes.array.isRequired,
  loadEnrollments: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  enrollments: state.enrollments,
});

const mapDispatchToProps = dispatch => ({
  loadEnrollments: () => dispatch(enrollmentActions.loadEnrollments()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Enrollments);
